var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('FormModelDisplay',{attrs:{"singleton":"","entity-repository":_vm.shopHeaderRepository,"i18n-group":"shopHeader"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }